
// isDuration 是否为时长格式
export const isDuration = (str) => {
    const reg = /^(?:\d+h)?(?:\d+m)?(?:\d+s)?(?:\d+ms)?$/;
    return reg.test(str);
};

// 是否为IPv4地址
export const isIPv4 = (str) => {
    const reg = /^((2[0-5][0-5]|1\d{2}|[1-9]\d|[1-9])\.){3}(2[0-5][0-5]|1\d{2}|[1-9]\d|[1-9])$/;
    return reg.test(str);
};

// 是否为IPv4网段
export const isIPv4Net = (str) => {
    const reg = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/([1-9]|[1-2][0-9]|3[0-2])$/;
    return reg.test(str);
};

// 是否为IPv4掩码
export const isIPv4Mask = (mask) => {
    if (!mask || typeof mask !== 'string') return false;
    // 将掩码分割为二进制字符串
    const binaryMask = mask.split('.').map(byte => {
        let bin = parseInt(byte, 10).toString(2);
        while (bin.length < 8) {
            bin = '0' + bin;
        }
        return bin;
    }).join('');

    // 检查是否有不是1或0的字符
    if (/\D/.test(binaryMask)) return false;

    // 检查是否有连续的0小于或等于32
    return !binaryMask.match(/0{2,}/);
};

const regexMaps = {
    email: /^\w+([-+.]\w+)*@\w+([-.]\\w+)*\.\w+([-.]\w+)*$/,
    urls: /^http|https:\/\/[A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\':+!]*([^<>\"\"])*$/,
    phone: /^((\(\d{3}\))|(\d{3}\-))?(\(0\d{2,3}\)|0\d{2,3}-)?[1-9]\d{6,7}$/,
    mobile: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
    idCard: /^\d{15}(\d{2}[A-Za-z0-9])?$/,
    currency: /^\d+(\.\d+)?$/,
    number: /^\d+$/,
    qq: /^[1-9]\d{4,8}$/,
    int: /^[-\+]?\d+$/,
    double: /^[-\+]?\d+(\.\d+)?$/,
    en: /^[A-Za-z]+$/,
    zh: /^[\u0391-\uFFE5]+$/,
    password: /^[\\w]{6,12}$/,
    zipCode: /^[\\d]{6}/,
    ip: /\d+\.\d+\.\d+\.\d+/,
    dateMonths: /^(0?[1-9]|1[0-2])$/,
    dateDays: /^((0?[1-9])|((1|2)[0-9])|30|31)$/,
};

export const isEmail = str => {
    return regexMaps.email.test(str);
};

export const isUrls = str => {
    return regexMaps.urls.test(str);
};

export const isPhone = str => {
    return regexMaps.phone.test(str);
};

export const isMobile = (str) => {
    return regexMaps.mobile.test(str);
};

export const isIdCard1 = str => {
    return regexMaps.idCard.test(str);
};

export const isIdCard = str => {
    // 权重因子数组
    const weights = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
    // 校验码数组
    const checkCodes = [ '1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2' ];

    const padNumber = (n, len) => {
        return n.toString().padStart(len, '0');
    };
    // 验证出生日期是否有效
    const isValidDate = (year, month, day) => {
        const testDate = `${year}-${padNumber(month, 2)}-${padNumber(day, 2)}`;
        const test = new Date(testDate);
        return !isNaN(test.getTime());
    };

    // 计算校验码
    const calcCheckCode = (id17) => {
        let sum = 0;
        const baseCode = '0'.charCodeAt(0);
        for (let i = 0; i < 17; i++) {
            '0'.charCodeAt(i);
            sum += ((id17 || '').charCodeAt(i) - baseCode) * weights[i];
        }
        return checkCodes[sum % 11];
    };

    if ((str || '').length !== 18) {
        return false;
    }
    for (let i = 0; i < str.length; i++) {
        if ((str || '').charCodeAt(i) < '0'.charCodeAt(0) || str.charCodeAt(i) > '9'.charCodeAt(0)) {
            return false;
        }
    }
    const year = Number.parseInt((str || '').substring(6, 10)); // 只取年份部分进行时间验证，忽略月份和日期，因为我们只关心年份是否有效，不考虑具体是哪一天。
    if (year > (new Date()).getFullYear()) { // 检查年份是否为未来年份
        return false;
    }
    const birthday = new Date(`${str.substring(6, 10)}-${str.substring(10, 12)}-${str.substring(12, 14)}`);
    if (isNaN(birthday.getTime())) {
        return false; // 如果日期格式不正确，则返回false
    }
    if (!isValidDate(birthday.getFullYear(), birthday.getMonth(), birthday.getDay())) { // 使用具体日期验证函数进行验证
        return false; // 如果日期不合法，则返回false
    }
    return calcCheckCode(str.substring(0, 17)) === str.substring(17); // 比较计算出的校验码和提供的校验码是否一致
};

export const isCurrency = str => {
    return regexMaps.currency.test(str);
};

export const isNumber = str => {
    return regexMaps.number.test(str);
};

export const isQQ = str => {
    return regexMaps.qq.test(str);
};

export const isENChars = str => {
    return regexMaps.en.test(str);
};

export const isZHChars = str => {
    return regexMaps.zh.test(str);
};

export const isZipCode = str => {
    return regexMaps.zipCode.test(str);
};

export const isIP = str => {
    return regexMaps.ip.test(str);
};

export const isDateMonths = str => {
    return regexMaps.dateMonths.test(str);
};

export const isDateDays = str => {
    return regexMaps.dateDays.test(str);
};
